export const posts = [
    {
        postId: 1,
        caption: 'The art of dying',
        publishedDate: '2020-04-30T13:19:24.481Z',
        imageUrl: 'https://picsum.photos/300/248',
        authorImage: 'https://i.pravatar.cc/24',
        author: 'Nifemi Adeyemi',
        content: `
            <p>
                Lorem ipsum dolor sit amet, consectetur adipisicing
                elit. Animi aperiam deserunt error incidunt
                inventore numquam quos ratione recusandae ut vitae.
                At consequatur, corporis distinctio eum excepturi
                explicabo facere quisquam tempora? Lorem ipsum dolor
                sit amet, consectetur adipisicing elit. Culpa dicta
                est facilis itaque libero magnam maiores nobis
                numquam optio perspiciatis quis quod soluta, sunt
                velit voluptates! Facere iusto mollitia sequi? Lorem
                ipsum dolor sit amet, consectetur adipisicing elit.
                Accusamus aliquam atque delectus deserunt ipsa
                nesciunt nobis odio, officiis, pariatur quis quos
                similique sint totam. Aut corporis exercitationem
                harum quas veniam. Lorem ipsum dolor sit amet,
                consectetur adipisicing elit. Asperiores deserunt
                eaque earum, excepturi nulla perspiciatis quaerat
                quia repudiandae sint? Adipisci pariatur quis unde
                voluptatibus voluptatum! Ad fuga nam numquam sed.
                <br />
                <br />
            </p>
            <p>
                Lorem ipsum dolor sit amet, consectetur adipisicing
                elit. Animi aperiam deserunt error incidunt
                inventore numquam quos ratione recusandae ut vitae.
                At consequatur, corporis distinctio eum excepturi
                explicabo facere quisquam tempora? Lorem ipsum dolor
                sit amet, consectetur adipisicing elit. Culpa dicta
                est facilis itaque libero magnam maiores nobis
                numquam optio perspiciatis quis quod soluta, sunt
                velit voluptates! Facere iusto mollitia sequi? Lorem
                ipsum dolor sit amet, consectetur adipisicing elit.
                Accusamus aliquam atque delectus deserunt ipsa
                nesciunt nobis odio, officiis, pariatur quis quos
                similique sint totam. Aut corporis exercitationem
                harum quas veniam. Lorem ipsum dolor sit amet,
                consectetur adipisicing elit. Asperiores deserunt
                eaque earum, excepturi nulla perspiciatis quaerat
                quia repudiandae sint? Adipisci pariatur quis unde
                voluptatibus voluptatum! Ad fuga nam numquam sed.
                <br />
                <br />
            </p>
        `,
    },
    {
        postId: 2,
        caption: 'The art of living',
        publishedDate: '2020-04-30T13:19:24.481Z',
        imageUrl: 'https://picsum.photos/300/248',
        authorImage: 'https://i.pravatar.cc/24',
        author: 'James Art',
        content: `
            <p>
                Lorem ipsum dolor sit amet, consectetur adipisicing
                elit. Animi aperiam deserunt error incidunt
                inventore numquam quos ratione recusandae ut vitae.
                At consequatur, corporis distinctio eum excepturi
                explicabo facere quisquam tempora? Lorem ipsum dolor
                sit amet, consectetur adipisicing elit. Culpa dicta
                est facilis itaque libero magnam maiores nobis
                numquam optio perspiciatis quis quod soluta, sunt
                velit voluptates! Facere iusto mollitia sequi? Lorem
                ipsum dolor sit amet, consectetur adipisicing elit.
                Accusamus aliquam atque delectus deserunt ipsa
                nesciunt nobis odio, officiis, pariatur quis quos
                similique sint totam. Aut corporis exercitationem
                harum quas veniam. Lorem ipsum dolor sit amet,
                consectetur adipisicing elit. Asperiores deserunt
                eaque earum, excepturi nulla perspiciatis quaerat
                quia repudiandae sint? Adipisci pariatur quis unde
                voluptatibus voluptatum! Ad fuga nam numquam sed.
                <br />
                <br />
            </p>
            <p>
                Lorem ipsum dolor sit amet, consectetur adipisicing
                elit. Animi aperiam deserunt error incidunt
                inventore numquam quos ratione recusandae ut vitae.
                At consequatur, corporis distinctio eum excepturi
                explicabo facere quisquam tempora? Lorem ipsum dolor
                sit amet, consectetur adipisicing elit. Culpa dicta
                est facilis itaque libero magnam maiores nobis
                numquam optio perspiciatis quis quod soluta, sunt
                velit voluptates! Facere iusto mollitia sequi? Lorem
                ipsum dolor sit amet, consectetur adipisicing elit.
                Accusamus aliquam atque delectus deserunt ipsa
                nesciunt nobis odio, officiis, pariatur quis quos
                similique sint totam. Aut corporis exercitationem
                harum quas veniam. Lorem ipsum dolor sit amet,
                consectetur adipisicing elit. Asperiores deserunt
                eaque earum, excepturi nulla perspiciatis quaerat
                quia repudiandae sint? Adipisci pariatur quis unde
                voluptatibus voluptatum! Ad fuga nam numquam sed.
                <br />
                <br />
            </p>
        `,
    },
    {
        postId: 3,
        caption: 'comethru',
        publishedDate: '2020-04-30T13:19:24.481Z',
        imageUrl: 'https://picsum.photos/300/248',
        authorImage: 'https://i.pravatar.cc/24',
        author: 'Victor Akinyemi',
        content: `
            <p>
                Lorem ipsum dolor sit amet, consectetur adipisicing
                elit. Animi aperiam deserunt error incidunt
                inventore numquam quos ratione recusandae ut vitae.
                At consequatur, corporis distinctio eum excepturi
                explicabo facere quisquam tempora? Lorem ipsum dolor
                sit amet, consectetur adipisicing elit. Culpa dicta
                est facilis itaque libero magnam maiores nobis
                numquam optio perspiciatis quis quod soluta, sunt
                velit voluptates! Facere iusto mollitia sequi? Lorem
                ipsum dolor sit amet, consectetur adipisicing elit.
                Accusamus aliquam atque delectus deserunt ipsa
                nesciunt nobis odio, officiis, pariatur quis quos
                similique sint totam. Aut corporis exercitationem
                harum quas veniam. Lorem ipsum dolor sit amet,
                consectetur adipisicing elit. Asperiores deserunt
                eaque earum, excepturi nulla perspiciatis quaerat
                quia repudiandae sint? Adipisci pariatur quis unde
                voluptatibus voluptatum! Ad fuga nam numquam sed.
                <br />
                <br />
            </p>
            <p>
                Lorem ipsum dolor sit amet, consectetur adipisicing
                elit. Animi aperiam deserunt error incidunt
                inventore numquam quos ratione recusandae ut vitae.
                At consequatur, corporis distinctio eum excepturi
                explicabo facere quisquam tempora? Lorem ipsum dolor
                sit amet, consectetur adipisicing elit. Culpa dicta
                est facilis itaque libero magnam maiores nobis
                numquam optio perspiciatis quis quod soluta, sunt
                velit voluptates! Facere iusto mollitia sequi? Lorem
                ipsum dolor sit amet, consectetur adipisicing elit.
                Accusamus aliquam atque delectus deserunt ipsa
                nesciunt nobis odio, officiis, pariatur quis quos
                similique sint totam. Aut corporis exercitationem
                harum quas veniam. Lorem ipsum dolor sit amet,
                consectetur adipisicing elit. Asperiores deserunt
                eaque earum, excepturi nulla perspiciatis quaerat
                quia repudiandae sint? Adipisci pariatur quis unde
                voluptatibus voluptatum! Ad fuga nam numquam sed.
                <br />
                <br />
            </p>
        `,
    },
]

export const searchResults = [
    {
        enrolled: 3,
        thumbnail: 'https://picsum.photos/seed/upturn/200/150',
        category: 'HUMAN RESOURCES',
        type: 'class',
        classid: 5,
        title: 'Artificial Intelligence and Business Development',
        duration: 120,
        startdate: '2019-06-26T00:00:00',
        coursedescription: 'An ideal class for all  tech enterprenur',
        timedescription: 'Mon,Wed, Fri 2:00 PM-4:00 PM',
        objectives:
            "Explains AI's relevance to busniess development;Teaches you the fundamentals of taking over the world... with your business ideas",
        loyalitypoint: 10,
        starttime: '2:00 PM',
        catid: '7',
        enddate: '2019-06-27T00:00:00',
        status: 'Upcoming',
        createdby: 'bigsam010@yahoo.com',
        price: 10000,
        location: 'Landen Piece Hotel, Abuja',
    },
    {
        enrolled: 3,
        thumbnail: 'https://picsum.photos/seed/upturn/200/150',
        category: 'HUMAN RESOURCES',
        type: 'class',
        classid: 2,
        title: 'Effective Human Capital Management and Development',
        duration: 120,
        startdate: '2019-06-27T00:00:00',
        coursedescription: 'An ideal class for all human resource managers',
        timedescription: 'Mon,Wed, Fri 2:00 PM-4:00 PM',
        objectives: 'Explains human capital;Improve human resource management',
        loyalitypoint: 20,
        starttime: '2:00 PM',
        catid: '5',
        enddate: '2019-07-25T00:00:00',
        status: 'Upcoming',
        createdby: 'samuelomotoso3@gmail.com',
        price: 10000,
        location: null,
    },
    {
        enrolled: 3,
        thumbnail: 'https://picsum.photos/seed/upturn/200/150',
        category: 'HUMAN RESOURCES',
        type: 'class',
        classid: 3,
        title: 'Human Capital Management and Financial Growth',
        duration: 80,
        startdate: '2019-07-01T00:00:00',
        coursedescription:
            'An ideal class for all human resource managers and top level managers',
        timedescription: 'Tue,Thur 9:00 AM-11:00 AM',
        objectives:
            'Improve financial development;Improve human resource management',
        loyalitypoint: 15,
        starttime: '9:00 AM',
        catid: '1;5',
        enddate: '2019-07-30T00:00:00',
        status: 'Upcoming',
        createdby: 'samuelomotoso3@gmail.com',
        price: 10000,
        location: null,
    },
    {
        enrolled: 3,
        thumbnail: 'https://picsum.photos/seed/upturn/200/150',
        category: 'HUMAN RESOURCES',
        type: 'class',
        classid: 4,
        title: 'Tech and Busniess Development',
        duration: 120,
        startdate: '2019-07-01T00:00:00',
        coursedescription: 'An business ',
        timedescription: 'Mon,Wed 9:00 AM-11:00 AM',
        objectives:
            'Improve financial development;Improve tech use in business development',
        loyalitypoint: 10,
        starttime: '9:00 AM',
        catid: '1;2',
        enddate: '2019-07-17T00:00:00',
        status: 'Upcoming',
        createdby: 'bigsam010@yahoo.com',
        price: 10000,
        location: null,
    },
    {
        enrolled: 3,
        thumbnail: 'https://picsum.photos/seed/upturn/200/150',
        category: 'HUMAN RESOURCES',
        type: 'course',
        downloadable: 20,
        lectures: 120,
        coursecode: 'FinMth20',
        duration: 120.5,
        title: 'Advanced Financail Mathematics',
        catid: '1',
        publisheddate: '2019-06-13T13:38:00.82',
        price: 20000,
        status: 'InDraft',
        author: 'bigsam010@yahoo.com',
        loyaltypoint: 15,
        enforcesequence: 1,
        freeonsubcription: 0,
        showstudentcount: 0,
        relatedcourses: 'FinMth10',
        description: 'Teaches the andvanced concepts of Financial Maths',
        tag: 'Financial;Math;Management;Advanced',
        objectives:
            'To provide managers financial maths skill; Help decision making process;Help in data analysis',
    },
    {
        enrolled: 3,
        thumbnail: 'https://picsum.photos/seed/upturn/200/150',
        category: 'HUMAN RESOURCES',
        type: 'course',
        downloadable: 20,
        lectures: 120,
        coursecode: 'DigMktt',
        duration: 100,
        title: 'Digitak Marketing',
        catid: '8',
        publisheddate: '2019-08-05T15:30:13.617',
        price: 20000,
        status: 'Published',
        author: 'bigsam010@yahoo.com',
        loyaltypoint: 15,
        enforcesequence: 1,
        freeonsubcription: 1,
        showstudentcount: 0,
        relatedcourses: 'EngTech',
        description: 'Teaches the andvanced concepts of digital marketing',
        tag: 'Marketing;Business development',
        objectives:
            'To provide marketers with diigital marketing skills; Help decision making process;Help in data analysis',
    },
    {
        enrolled: 3,
        thumbnail: 'https://picsum.photos/seed/upturn/200/150',
        category: 'HUMAN RESOURCES',
        type: 'course',
        downloadable: 20,
        lectures: 120,
        coursecode: 'EngTech',
        duration: 120,
        title: 'Engineering, Technology and Business Development',
        catid: '7',
        publisheddate: '2019-08-06T09:43:13.033',
        price: 50000,
        status: 'Published',
        author: 'bigsam010@yahoo.com',
        loyaltypoint: 15,
        enforcesequence: 1,
        freeonsubcription: 1,
        showstudentcount: 0,
        relatedcourses: 'MicEco',
        description:
            'Teaches the core of applying engineering and technology in business development',
        tag: 'Engineering;Technology;Business Development',
        objectives:
            'To provide managers business devlopement skill; Help decision making process',
    },
    {
        enrolled: 3,
        thumbnail: 'https://picsum.photos/seed/upturn/200/150',
        category: 'HUMAN RESOURCES',
        type: 'course',
        downloadable: 20,
        lectures: 120,
        coursecode: 'FinMth10',
        duration: 120.5,
        title: 'Introduction to Financial Mathematics',
        catid: '1',
        publisheddate: '2019-06-13T13:25:41.283',
        price: 10000,
        status: 'InDraft',
        author: 'bigsam010@yahoo.com',
        loyaltypoint: 10,
        enforcesequence: 1,
        freeonsubcription: 0,
        showstudentcount: 0,
        relatedcourses: '',
        description: 'Teaches the core of Financial Maths',
        tag: 'Financial;Math;Management',
        objectives:
            'To provide managers financial maths skill; Help decision making process',
    },
    {
        enrolled: 3,
        thumbnail: 'https://picsum.photos/seed/upturn/200/150',
        category: 'HUMAN RESOURCES',
        type: 'course',
        downloadable: 20,
        lectures: 120,
        coursecode: 'MicEco',
        duration: 170,
        title: 'Micro Economics',
        catid: '1;2',
        publisheddate: '2019-06-20T09:21:59.91',
        price: 20000,
        status: 'Published',
        author: 'samuelomotoso3@gmail.com',
        loyaltypoint: 10,
        enforcesequence: 1,
        freeonsubcription: 1,
        showstudentcount: 0,
        relatedcourses: 'FinMth20;Primgt',
        description: 'The core of Micro Economics',
        tag: 'Economics;Principle',
        objectives:
            'To provide business developers the principle of Micro Economics;To understand the Micro Economics in the Nigerian context',
    },
    {
        enrolled: 3,
        thumbnail: 'https://picsum.photos/seed/upturn/200/150',
        category: 'HUMAN RESOURCES',
        type: 'course',
        downloadable: 20,
        lectures: 120,
        coursecode: 'PriMgt',
        duration: 80,
        title: 'Principle of Management',
        catid: '2',
        publisheddate: '2019-08-07T11:17:22.593',
        price: 50000,
        status: 'Published',
        author: 'lmsadmin@prunedge.com',
        loyaltypoint: 15,
        enforcesequence: 1,
        freeonsubcription: 1,
        showstudentcount: 0,
        relatedcourses: 'FinMth10;FinMth20',
        description: 'Teaches the andvanced concepts of Management',
        tag: 'Management;Principle',
        objectives:
            'To provide managers financial maths skill; Help decision making process;Help in data analysis',
    },
]
